/**
 * The kit's words in the page's language (REQUESTS #141 a, HANDOFF §0.9 "Kit words and dates"): every label of
 * `@brevalt/ui`'s `kitLabelKeys`, read from a catalogue. Built from the map, so a label design adds to the kit is
 * picked up without a change here; the apps' builds load the keys because they name `kit-labels.ts` (the app's and
 * the theme's `initialSources`, the site's client-copy generator).
 *
 * The messages go to the kit RAW: the kit fills `{label}`, `{time}`, `{local}`, `{utc}`, `{caseId}`, `{value}` and
 * renders `<b>` itself. A label the catalogue lacks is left out, so the kit's English default stays.
 */
import { kitLabelKeys, type KitLabels } from "@brevalt/ui";

export function kitLabelsFrom(message: (key: string) => unknown): Partial<KitLabels> {
  const labels: Partial<KitLabels> = {};
  for (const [label, key] of Object.entries(kitLabelKeys) as [keyof KitLabels, string][]) {
    const raw = message(key);
    if (typeof raw === "string" && raw !== "") labels[label] = raw;
  }
  return labels;
}

/** The kit's `Intl` locale for a UI locale ("en" → "en-GB", "pl" → "pl"): for apps without app-core's index. */
export { intlLocale } from "./locale";
